export const filtrosVazios = {
  assunto: "",
  dataEntrada: {
    startDate: new Date(new Date().getFullYear(), 0, 1),
    endDate: new Date(new Date().getFullYear(), 11, 31),
  },
  dataJulgamento: { startDate: null, endDate: null },
  interessado: "",
  julgado: 0,
  numero: "",
  situacao: "2",
  tipo: "",
  ug: null,
};
